import axios from "axios";
import authHeader from './utils/auth-header';

const API_URL = '/OppPortal/api/v1/opp/';

class OppService {

    isAlive() {
        return axios.get(API_URL + `isAlive`, {headers: authHeader()});
    }

    isAntivirusAlive() {
        return axios.get(API_URL + `antivirus/isAlive`, {headers: authHeader()});
    }

    isDatabaseAlive() {
        return axios.get(API_URL + `database/isAlive`, {headers: authHeader()});
    }

    getLSFields() {
        return axios.get(API_URL + `leadspace/fields`, {headers: authHeader()});
    }

    getLSContactFields() {
        return axios.get(API_URL + `leadspace/fields/contact`, {headers: authHeader()});
    }

    isUnderMaintenance(app) {
        return axios.get(API_URL + `isUnderMaintenance?app=${app}`, {headers: authHeader()});
    }

    setMaintenance(app, enabled) {
        return axios.post(API_URL + `setMaintenance?app=${app}&enabled=${enabled}`)
    }
}

export default new OppService();